import { useEffect } from "react";
// set it to true to test merchZones
const enableTest = false;

export const MerchZonesProvider = () => {
  useEffect(() => {
    if (enableTest) {
      document.dispatchEvent(
        new CustomEvent("priceAndRenderRecommendations", {
          detail: {
            merchZoneId: "merch-zone-responsive-search",
            couponId: "1ND",
          },
        })
      );
    }
  }, []);
  return (
    <>
      {enableTest && (
        <>
          <div className="merch-section" style={{ display: "none" }}>
            <div>
              <div>
                <div id="merch-zone-responsive-search">
                  <div
                    className="react-horizontal-scrolling-menu--item merchZone-item"
                    data-item="WAU22651|RM"
                    data-key="id-1"
                    data-index="1"
                  >
                    <div>
                      <div className="_content_14rkh_1">
                        <div className="_container_d7y7q_1 _container_14rkh_7">
                          <div className="_productDesktop_x72y9_8">
                            <a className="mzs-product-link">
                              <img
                                className="_imgDesktop_x72y9_29"
                                alt="Swingline� Light Touch Reduced Effort Full Strip Stapler, 20-Sheet Capacity, Blue"
                                src="https://content.etilize.com/240//1012682993.jpg"
                              />
                            </a>
                            <div className="_textDesktop_x72y9_51 wbm-product-name">
                              <div className="mzs-item-text">
                                <a className="mzs-product-link">
                                  <div className="product-description mzs-item-description">
                                    Swingline� Light Touch Reduced Effort Full
                                    Strip Stapler, 20-Sheet Capacity, Blue
                                  </div>
                                  <div className="product-id">WAU22651</div>
                                </a>
                              </div>
                              <div className="_priceDesktop_x72y9_55">
                                <span>
                                  <span>
                                    <span className="_h4_vyrlo_160 _line-height-normal_vyrlo_1 merch-price"></span>
                                  </span>
                                  <span className="wbm-product-pricing">
                                    <span className="unit-id">RM</span>
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="mzs-availibility-container"
                            style={{ display: "none" }}
                          ></div>
                          <div className="_actions_14rkh_20">
                            <div className="_dropdown_14rkh_26">
                              <div className="_wrapper_1a9ij_1">
                                <div className="wb-relative wb-grid mzs-dropdown">
                                  <input
                                    name="mzs-qty-add-to-cart"
                                    type="text"
                                    placeholder="1"
                                    className="mzs-qty-add-to-cart"
                                    inputMode="numeric"
                                    tabIndex={0}
                                    aria-label="Quantity"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="_btn_14rkh_30">
                              <button
                                aria-disabled="false"
                                className="wb-border-radius-4 wb-pointer _fullWidth_lnnix_51 _button_lnnix_1 _lightActive_lnnix_106 _sizeLarge_lnnix_41 mzs-btn-add-to-cart"
                              >
                                <div className="_children_lnnix_16 wb-flex wb-gap-8">
                                  <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                    focusable="false"
                                    color="inherit"
                                    aria-hidden="true"
                                    viewBox="0 0 24 24"
                                    data-testid="AddShoppingCartOutlinedIcon"
                                    style={{ display: "block" }}
                                  >
                                    <path d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"></path>
                                  </svg>
                                  ADD
                                </div>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
